import React from 'react';
import CalendarContentBig from './CalendarContentBig';
import CalendarContentSmall from './CalendarContentSmall';
import type { CalendarContentProps } from '../../../types';

const CalendarContent = (props: CalendarContentProps) => (
  <>
    <CalendarContentBig {...props} />
    <CalendarContentSmall {...props} />
  </>
);

export default CalendarContent;
